import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFriendsWithBenefits = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(27.1353 23.2318)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M27.4858 36.08L32.6758 9.76999C33.1958 7.15999 31.4558 4.62999 28.8058 4.11999L11.6558 0.83999C9.0058 0.32999 6.4358 2.03999 5.9158 4.64999L0.7358 30.89",
					stroke: "#311123",
					strokeWidth: 1.5,
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.2758 10.22C30.6458 8.33999 29.3958 6.51999 27.4858 6.14999L12.1058 3.20999C10.1958 2.83999 8.3458 4.06999 7.9758 5.94999L2.9658 31.32L25.2558 35.65L30.2758 10.22Z",
					fill: "#FDD2CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.8158 15.17C11.4758 17.69 13.5658 18.09 16.0758 16.35",
					stroke: "#311123",
					strokeWidth: 1.5,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.6858 26.28C14.0958 28.62 16.5758 29.01 19.1458 27.45",
					stroke: "#311123",
					strokeWidth: 1.5,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.4858 17.11C21.1458 19.63 23.2358 20.03 25.7458 18.29",
					stroke: "#311123",
					strokeWidth: 1.5,
					strokeMiterlimit: 10
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(1.8683 12.7623)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M30.846 16.8591L26.976 4.13914C26.206 1.58914 23.486 0.179139 20.906 0.969139L4.22595 6.13914C1.64595 6.93914 0.185952 9.64914 0.955952 12.1991L8.72595 37.7891",
					stroke: "#311123",
					strokeWidth: 1.5,
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.076 5.65914C24.516 3.82914 22.556 2.80914 20.696 3.37914L5.74595 8.01914C3.88595 8.58914 2.83595 10.5491 3.38595 12.3791L10.896 37.1191L27.046 32.1591L28.366 25.6291L29.406 20.1691L25.056 5.65914H25.076Z",
					fill: "#D0F5DA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.34595 19.6491C11.996 21.0891 14.026 20.4591 15.426 17.7491C14.026 20.4691 11.996 21.0991 9.34595 19.6491Z",
					fill: "#FF6047",
					stroke: "#311123",
					strokeWidth: 1.5,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.226 28.5791C19.456 29.5091 21.826 28.6891 23.356 26.0991C21.826 28.6891 19.446 29.5091 16.226 28.5791Z",
					fill: "#FF6047",
					stroke: "#311123",
					strokeWidth: 1.5,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.796 16.8191C21.446 18.2591 23.476 17.6291 24.876 14.9191C23.476 17.6391 21.446 18.2691 18.796 16.8191Z",
					fill: "#FF6047",
					stroke: "#311123",
					strokeWidth: 1.5,
					strokeMiterlimit: 10
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(31.2505 7.2494)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5.10818 12.5406C5.10818 12.5406 0.0681791 7.86057 0.828179 3.57057C1.16818 1.63057 2.88818 0.490573 4.69818 0.800573C5.83818 1.00057 6.59818 1.76057 6.83818 2.76057C7.39818 1.89057 8.38818 1.45057 9.51818 1.65057C11.3282 1.97057 12.5482 3.64057 12.2082 5.58057C11.4482 9.86057 5.10818 12.5506 5.10818 12.5506V12.5406Z",
				fill: "#FF6047",
				stroke: "#311123",
				strokeWidth: 1.5,
				strokeMiterlimit: 10,
				strokeLinejoin: "round"
			})
		})
	]
});
export default SvgFriendsWithBenefits;
